// import React from "react"

const navigationlinks = {
  admin: [
    {
      name: "Users",
      url: "/users",
    },
    {
      name: "Library",
      url: "/library",
    },
    {
      name: "Campaigns",
      url: "/campaigns",
    },
    {
      name: "Content",
      url: "/content",
    },
    {
      name: "Displays",
      url: "/displays",
    },
    {
      name: "Report",
      url: "/report",
    },
    {
      name: "Settings",
      url: "/settings",
    },
  ],
  carrier: [
    {
      name: "Displays",
      url: "/displays",
    },
    {
      name: "Vehicles",
      url: "/vehicles",
    },
  ],
  advertiser: [
    {
      name: "Library",
      url: "/library",
    },
    {
      name: "Campaigns",
      url: "/campaigns",
    },
    {
      name: "Report",
      url: "/report",
    },
  ],
  "advertiser,carrier": [
    {
      name: "Library",
      url: "/library",
    },
    {
      name: "Campaigns",
      url: "/campaigns",
    },
    {
      name: "Displays",
      url: "/displays",
    },
    {
      name: "Vehicles",
      url: "/vehicles",
    },
    {
      name: "Report",
      url: "/report",
    },
  ],
}

export default navigationlinks
